import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

import { onMounted } from "vue";
import { RoleModelFragment } from "@/graphql/types";
import { useRoleColumns } from "./useRoleColumns";
import { useUpdateRole } from "./useUpdateRole";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateRole',
  props: {
    role: {}
  },
  setup(__props: any) {

const props = __props;

const { columns, accessText } = useRoleColumns();

const { loading, submit, form, hasError, onCellEditComplete, reset } =
  useUpdateRole();

onMounted(() => {
  reset(props.role);
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(submit)(_ctx.role.id)), ["prevent"]))
  }, [
    _createVNode(_component_DataTable, {
      editMode: "cell",
      onCellEditComplete: _unref(onCellEditComplete),
      value: _unref(form).access.$value
    }, {
      header: _withCtx(() => [
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _unref(form).name.$value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name.$value) = $event)),
          placeholder: "Nouveau nom du rôle",
          class: _normalizeClass({ 'p-invalid': _unref(form).name.$hasError })
        }, null, 8, ["modelValue", "class"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          disabled: _unref(hasError) || _unref(loading),
          type: "submit",
          icon: "pi pi-save",
          label: _ctx.$t('save')
        }, null, 8, ["disabled", "label"])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), (col, index) => {
          return (_openBlock(), _createBlock(_component_Column, {
            field: col.field,
            header: col.header,
            key: `roles-col-custom-${index}`
          }, {
            body: _withCtx(({ data, field }) => [
              _createTextVNode(_toDisplayString(_unref(accessText)(data[field])), 1)
            ]),
            editor: _withCtx(({ data, field }) => [
              _createVNode(_component_Checkbox, {
                modelValue: data[field],
                "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
                binary: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["field", "header"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onCellEditComplete", "value"])
  ], 32))
}
}

})